var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":[
    { text: 'Abernathy Ltd a' },
    { text: 'Alex Test School 002 (EN)' },
    { text: 'Alex Test School 003 (NL)' },
    { text: 'Bett English' },
  ],"label":_vm.$t('school.select'),"single-line":"","append-icon":"keyboard_arrow_down"}})
}
var staticRenderFns = []

export { render, staticRenderFns }